import { createContext } from "react"

export interface ComplaintInterface {
  _id: string,
  fullName: string;
  phone: string;
  RegNo: string;
  cabinetName: string;
  doctorName: string;
  devis: string;
  message: string;
  view: boolean;
}

export const DefaultComplaintInterface: ComplaintInterface =  {
  _id: "",
  fullName: "",
  phone: "",
  RegNo: "",
  cabinetName: "",
  doctorName: "",
  devis: "",
  message: "",
  view: false,
}


export interface ShowComplaintsInterface {
  showSuccessMsg: boolean,
  setShowSuccessMsg: (showSuccessMsg: boolean) => void,
  showAddModal: boolean,
  setShowAddModal: (showAddModal: boolean) => void,
  showEditModal: boolean,
  setShowEditModal: (showEditModal: boolean) => void,
  showDeleteModal: boolean, 
  setShowDeleteModal: (showDeleteModal: boolean) => void,
  selectedComplaint:ComplaintInterface,
  setSelectedComplaint: (selectedComplaint:ComplaintInterface) => void,
  selectedDoctor: any,
  setSelectedDoctor: (selectedDoctor: any) => void,
  hideDataComplaint: boolean,
  setHideDataComplaint: (hideDataComplaint: boolean) => void,
}

export const DefaultShowComplaintsInterface:ShowComplaintsInterface = {
  showSuccessMsg: false,
  setShowSuccessMsg: () => {},
  showAddModal: false,
  setShowAddModal: () => {},
  showEditModal: false,
  setShowEditModal: () => {},
  showDeleteModal: false, 
  setShowDeleteModal: () => {},
  selectedComplaint: DefaultComplaintInterface,
  setSelectedComplaint: () => {},
  selectedDoctor: {},
  setSelectedDoctor: () => {},
  hideDataComplaint: false,
  setHideDataComplaint: () => {},
}

export const ShowComplaintsContext = createContext(DefaultShowComplaintsInterface)


export interface DataComplaintInterface {
  fullName: string, setFullName: (fullName: string) => void,
  phone: string, setPhone: (phone: string) => void,
  RegNo: string, setRegNo: (RegNo: string) => void,
  cabinetName: string, setCabinetName: (cabinetName: string) => void,
  doctorName: string, setDoctorName: (doctorName: string) => void,
  devis: File | any, setDevis: (devis: File | any) => void,
  message: string, setMessage: (message: string) => void,
  view: boolean, setView: (view: boolean) => void,
}

export const DefaultDataComplaintInterface: DataComplaintInterface = {
  fullName: "", setFullName: () => {},
  phone: "", setPhone: () => {},
  RegNo: "", setRegNo: () => {},
  cabinetName: "", setCabinetName: () => {},
  doctorName: "", setDoctorName: () => {},
  devis: null, setDevis: () => {},
  message: "", setMessage: () => {},
  view: false, setView: () => {},
}

export const DataComplaintContext = createContext(DefaultDataComplaintInterface)
